import { getSelfAppDataOptions } from '../../../../@api-client/@tanstack/react-query.gen';

export const getCachedSelfAppDataOptions = () => ({
  ...getSelfAppDataOptions({}),
  networkMode: 'offlineFirst' as const,
  refetchOnMount: false,
});
